export const CASHIER_NAVIGATE_COOKIE_NAME = 'cashier-navigate';
export const CASHIER_NAVIGATE_COOKIE_VALUE = 'true';
